import { c } from '../../contract';
import { revenueJarRouter } from './revenue-jar.router';
import { userRouter } from './user.router';

export const v3Router = c.router(
  {
    revenueJar: revenueJarRouter,
    user: userRouter,
  },
  { pathPrefix: '/v3' },
);
